/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createSelector } from 'reselect';

import p from 'polyglot/polyglot';

const INPUTS = [
  'title',
  'description',
  'dates',
  'has_flexible_dates',
  'location',
  'usage_rights',
];

const getJob = state => state.job;
const getJobForm = state => state.jobForm;
const getConstants = state => state.bootstrap.constants;

export const makeUpdateJobForm = () =>
  createSelector(
    [getJob, getJobForm, getConstants],
    (job, jobForm, constants) => {
      const fieldsets = jobForm.fieldsets.map(({ legend, inputs }) => ({
        legend,
        inputs: inputs
          .map(input =>
            input.name === 'usage_rights'
              ? { ...input, options: constants.job_usages }
              : input
          )
          .map(input => {
            if (input.name === 'picture_cloudinary_public_id') {
              const { picture } = job;

              return {
                ...input,
                preview: picture ? picture.thumbnail_url : '',
                value: picture ? picture.cloudinary_id : '',
              };
            }

            return input;
          })
          .map(input =>
            typeof job[input.name] !== 'undefined'
              ? { ...input, value: job[input.name] }
              : input
          ),
      }));

      return {
        ...jobForm,
        fieldsets: fieldsets.map(({ legend, inputs }) => ({
          legend,
          inputs: inputs.filter(input => INPUTS.indexOf(input.name) !== -1),
        })),
        submitText: p.t('jobs.update.form.submit'),
      };
    }
  );
